import React, { useState } from "react";
import s from "./ActionPopOverDetails.module.scss";
import { EyeOpenIcon } from "../../../../../../../../global components/Icons/EyeOpenIcon";
import { XCircleSolid } from "../../../../../../../../global components/Icons/XCircleSolid";
import { useNavigate } from "react-router-dom";
import ReusableModal from "../../../../../../../../global components/Modal/Modal";
import DisableApiKey from "../../../../local components/DisableApiKey";
type PropType = {
  mutate: () => void;
  id: string;
  previewAPI: string;
};
function ActionPopOverDetails({ mutate, id, previewAPI }: PropType) {
  const [openModal, setOpenModal] = useState<boolean>(false);
  const navigate = useNavigate();
  const items: { label: string; icon: React.ReactNode; action: () => void }[] =
    [
      {
        label: "View details",
        action: () =>
          navigate(
            `/dashboard/api-management/requests/ranking/activity-details/${id}`
          ),
        icon: <EyeOpenIcon className={s.icon} />,
      },
      {
        label: "Revoke key",
        action: () => handleModal(),
        icon: <XCircleSolid className={s.icon} />,
      },
    ];
  const handleModal = () => {
    setOpenModal((prev) => !prev);
  };
  return (
    <>
      <div className={s.wrapper}>
        {items.map((item, index) => (
          <div key={index} className={s.item} onClick={item.action}>
            {item.icon} <p className={s.label}>{item.label}</p>
          </div>
        ))}
      </div>
      <ReusableModal
        isModalOpen={openModal}
        handleModal={handleModal}
        width={682}
      >
        <DisableApiKey
          emptyKey={previewAPI}
          handleModal={handleModal}
          mutate={mutate}
          id={id}
        />
      </ReusableModal>
    </>
  );
}

export default ActionPopOverDetails;
